import { useEffect, useState } from "react";
import AccountPage from "../../Component/Elements/Page/AccountPage/AccountPage";
import LoginInputContainer from "./components/LoginInputContainer/LoginInputContainer";
import CSS from "./static/css/login.module.css";
import splashFirefly from "./static/img/figma-splash-firefly.png";

function Login() {
    const searchParams = new URLSearchParams(window.location.search);
    const isLocalPreviewHost = ["localhost", "127.0.0.1"].includes(window.location.hostname);
    const isPreviewDeviceEntry =
        (isLocalPreviewHost && window.location.pathname === "/")
        || window.location.pathname === "/mobile"
        || window.location.pathname === "/tablet";
    const shouldSkipSplash = searchParams.get("screen") === "login" || isPreviewDeviceEntry;
    const [page, setPage] = useState<"splash" | "login">(shouldSkipSplash ? "login" : "splash");

    useEffect(() => {
        if(page === "login"){
            return;
        }

        const timer = window.setTimeout(() => {
            setPage("login");
        }, 1400);

        return () => {
            window.clearTimeout(timer);
        };
    }, [page]);

    return (
        <AccountPage className={CSS.l_Login_accountPage}>
            <div className={CSS.l_Login_main}>
                {
                    page === "splash"
                    ?   <button
                            type="button"
                            className={CSS.l_Login_splashScreen}
                            onClick={() => setPage("login")}
                            aria-label="로그인 화면으로 이동"
                            data-node-id="7123:21780"
                        >
                            <img src={splashFirefly} alt="럽맘 스튜디오 앱 스플래시" />
                        </button>
                    :   <div className={CSS.l_Login_LoginInputContainer} data-node-id="7116:1089">
                            <LoginInputContainer />
                        </div>
                }
            </div>
        </AccountPage>
    );
}
export default Login;
